import { cn } from '@/lib/utils';

export const commerceNotificationDesktopWidthClassName =
    'box-border rounded-lg border overflow-hidden border-sand-90 bg-neutral-white w-max max-w-[min(500px,calc(100vw-2rem))] min-w-0 border border-sand-90 bg-neutral-white';

export const commerceNotificationMessageClassName =
    'flex-1 lg:pr-2 whitespace-normal break-words text-base leading-6 tracking-[0.16px] text-foreground';

export type CommerceFeedbackPresentation = 'toast' | 'drawer';

/** Inner padding for commerce feedback; toast reserves space for Sonner close, drawer uses shell dismiss. */
export function commerceFeedbackContentClassName(presentation: CommerceFeedbackPresentation = 'toast'): string {
    return cn('min-w-0', presentation === 'toast' ? 'py-4 pl-6 pr-16' : 'py-0');
}

/** @deprecated Use commerceFeedbackContentClassName('toast') */
export const commerceFeedbackSimpleToastContentClassName = commerceFeedbackContentClassName('toast');

export const commerceNotificationCardClassName = cn(
    'relative box-border min-w-0',
    'rounded-lg border border-[var(--sand-90)] bg-[var(--sand-95)]',
    'lg:py-4 lg:pl-6 lg:pr-14 lg:top-5 lg:right-4',
    'shadow-[0px_4px_12px_0px_rgba(0,0,0,0.05)]'
);

/** Positions the dismiss control on the desktop commerce notification card (`lg`). */
export const commerceNotificationDismissLayoutClassName = 'lg:absolute self-start lg:top-4 lg:right-6';
